import navConfig from '@app/routes/navigationConfig';
import DynamicMenu from '@widgets/DynamicMenu';
import { filterNavItemsByParentAccess, useUserCredentials } from '@shared/utils/auth';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t, i18n } = useTranslation();
  const { roles: userRoles, hasRoleAccessAny } = useUserCredentials();
  const allowedNav = filterNavItemsByParentAccess(navConfig, userRoles, hasRoleAccessAny);
  
  return (
    <nav>
      <DynamicMenu navItems={allowedNav} t={t} />
    </nav>
  );
};

export default Home;
